import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

// Import your Parameter components
import ViewParameter from "./ViewParameter";
import Create_Parameter from "./Create_Parameter";
import Map_ParaToDevice from "./Map_ParaToDevice";
import Group_Parameter from "./Group_Parameter";

const steps = [
  "View Parameters",
  "Create Parameter",
  "Map to Device",
  "Group Parameters",
];

export default function ManageParameter() {
  const [activeStep, setActiveStep] = useState(0);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <ViewParameter />;
      case 1:
        return <Create_Parameter />;
      case 2:
        return <Map_ParaToDevice />;
      case 3:
        return <Group_Parameter />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 1500,
        mx: "auto",
        py: 4,
        px: 2,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: "bold",
          textAlign: "left",
          borderBottom: "2px solid #1976d2",
          display: "inline-block",
        }}
      >
        Manage Parameters
      </Typography>

      {/* Wizard Stepper */}
      <Card
        sx={{
          p: 1,
          mb: 2,
          borderRadius: 3,
          boxShadow: 4,
          overflowX: "auto", // allows horizontal scroll on small screens
        }}
      >
        <Box
          sx={{
            minWidth: { xs: "auto", sm: 0 },
          }}
        >
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            nonLinear
            sx={{
              flexWrap: { xs: "nowrap", sm: "wrap" },
              "& .MuiStep-root": {
                flex: "1 1 auto",
                minWidth: { xs: 120, sm: "auto" },
              },
            }}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  onClick={() => setActiveStep(index)}
                  StepIconProps={{
                  sx: {
                    cursor: "pointer",
                    fontWeight: "bold",
                    color: "grey.400",

                     "& .MuiStepIcon-text": {
        fill: "#000",
        fontWeight: "bold",
      },
                    "&.Mui-active": {
                       color: "#EE7F1A",
                      transform: "scale(1.3)",
                      transition: "all 0.3s",
                    },
                    "&.Mui-completed": {
                     color: "#EE7F1A",
                    },
                  },
                }}
                sx={{
                  cursor: "pointer",
                  "&:hover": { color: "primary.light", fontWeight: "bold" },
                }}
              >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Card>

      {/* Animated Step Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeStep}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.4 }}
        >
          <Paper
            elevation={6}
            sx={{
              p: 2,
              borderRadius: 3,
              minHeight: 400,
              mb: 1,
               background: "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)",
            }}
          >
            {renderStepContent(activeStep)}
          </Paper>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
}